"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importStar(require("react"));
const carbon_components_react_1 = require("carbon-components-react");
const settings_1 = tslib_1.__importDefault(require("../settings"));
const { prefix } = settings_1.default;
const CLASS_TILE = `${prefix}-tile-component`;
const CLASS_CLICKABLE_TILE = `${prefix}-clickable-tile-component`;
const CLASS_SELECTABLE_TILE = `${prefix}-selectable-tile-component`;
const CLASS_EXPANDABLE_TILE = `${prefix}-expandable-tile-component`;
class Tile extends react_1.Component {
    render() {
        const _a = this.props, { 
        // remove - remapped
        'data-tid': dataTid } = _a, 
        // pass all other props to Carbon Tile
        otherTileProps = tslib_1.__rest(_a, ['data-tid']);
        const mappedDataTid = (dataTid !== null && dataTid !== void 0 ? dataTid : CLASS_TILE);
        return react_1.default.createElement(carbon_components_react_1.Tile, Object.assign({ "data-tid": mappedDataTid }, otherTileProps));
    }
}
exports.Tile = Tile;
Tile.propTypes = Object.assign({}, carbon_components_react_1.Tile.propTypes);
Tile.defaultProps = Object.assign({}, carbon_components_react_1.Tile.defaultProps);
class ClickableTile extends react_1.Component {
    constructor() {
        super(...arguments);
        this._onHandleClick = (e) => {
            const { onSelect, handleClick } = this.props;
            handleClick && handleClick(e);
            onSelect && onSelect();
        };
        this._onHandleKeyDown = (e) => {
            const { onSelect, handleKeyDown } = this.props;
            handleKeyDown && handleKeyDown(e);
            if (e.key === 'SPACE' || e.key === 'ENTER') {
                onSelect && onSelect();
            }
        };
    }
    render() {
        const _a = this.props, { 
        // remove - remapped
        'data-tid': dataTid } = _a, 
        // pass all other props to Carbon ClickableTile
        otherClickableTileProps = tslib_1.__rest(_a, ['data-tid']);
        const mappedDataTid = (dataTid !== null && dataTid !== void 0 ? dataTid : CLASS_CLICKABLE_TILE);
        return (react_1.default.createElement(carbon_components_react_1.ClickableTile, Object.assign({ "data-tid": mappedDataTid }, otherClickableTileProps, { handleClick: this._onHandleClick, handleKeyDown: this._onHandleKeyDown })));
    }
}
exports.ClickableTile = ClickableTile;
ClickableTile.propTypes = Object.assign(Object.assign({}, carbon_components_react_1.ClickableTile.propTypes), { onSelect: prop_types_1.default.func, handleClick: prop_types_1.default.func, handleKeyDown: prop_types_1.default.func });
ClickableTile.defaultProps = Object.assign({}, carbon_components_react_1.ClickableTile.defaultProps);
class SelectableTile extends react_1.Component {
    constructor() {
        super(...arguments);
        this._onHandleClick = (e) => {
            const { onSelect, handleClick } = this.props;
            handleClick && handleClick(e);
            onSelect && onSelect();
        };
        this._onHandleKeyDown = (e) => {
            const { onSelect, handleKeyDown } = this.props;
            handleKeyDown && handleKeyDown(e);
            if (e.key === 'SPACE' || e.key === 'ENTER') {
                onSelect && onSelect();
            }
        };
    }
    render() {
        const _a = this.props, { 
        // remove - remapped
        'data-tid': dataTid } = _a, 
        // pass all other props to Carbon SelectableTile
        otherSelectableTileProps = tslib_1.__rest(_a, ['data-tid']);
        const mappedDataTid = (dataTid !== null && dataTid !== void 0 ? dataTid : CLASS_SELECTABLE_TILE);
        return (react_1.default.createElement(carbon_components_react_1.SelectableTile, Object.assign({ "data-tid": mappedDataTid }, otherSelectableTileProps, { handleClick: this._onHandleClick, handleKeyDown: this._onHandleKeyDown })));
    }
}
exports.SelectableTile = SelectableTile;
SelectableTile.propTypes = Object.assign(Object.assign({}, carbon_components_react_1.SelectableTile.propTypes), { onSelect: prop_types_1.default.func, handleClick: prop_types_1.default.func, handleKeyDown: prop_types_1.default.func });
SelectableTile.defaultProps = Object.assign({}, carbon_components_react_1.SelectableTile.defaultProps);
class ExpandableTile extends react_1.Component {
    render() {
        const _a = this.props, { 
        // remove - remapped
        'data-tid': dataTid } = _a, 
        // pass all other props to Carbon ExpandableTile
        otherExpandableTileProps = tslib_1.__rest(_a, ['data-tid']);
        const mappedDataTid = (dataTid !== null && dataTid !== void 0 ? dataTid : CLASS_EXPANDABLE_TILE);
        return react_1.default.createElement(carbon_components_react_1.ExpandableTile, Object.assign({ "data-tid": mappedDataTid }, otherExpandableTileProps));
    }
}
exports.ExpandableTile = ExpandableTile;
ExpandableTile.propTypes = Object.assign({}, carbon_components_react_1.ExpandableTile.propTypes);
ExpandableTile.defaultProps = Object.assign({}, carbon_components_react_1.ExpandableTile.defaultProps);
